module.exports = __webpack_public_path__ + "img/close-button.012a0bb4.svg";